$(document).on("click", ".load-modal", e => {
  e.preventDefault();

  const currentTarget = $(e.currentTarget);
  const url = currentTarget.attr("data-url");

  if (!url) {
    throw new Error("The .load-modal class triggers a backend-driven modal, but no URL was provided.");
  }

  const loadingLabel = currentTarget.attr("data-disable-with") || "Loading...";
  const label = currentTarget.html();

  // Prevent parent popover from becoming sticky
  currentTarget.closest('[data-toggle="popover"]').popover('hide');
  // Prevent child popover from becoming sticky
  currentTarget.find('[data-toggle="popover"]').popover('hide');

  currentTarget.html(loadingLabel);
  currentTarget.addClass("disabled");
  currentTarget.prop("disabled", true);

  $.ajax({
    url,
    success: async data => {
      const modal = $(data).closest('.modal');

      if (currentTarget.attr("data-modal-container")) {
        $(currentTarget.attr("data-modal-container")).append(modal);
      } else {
        $("body").append(modal);
      }

      modal.on("hidden.bs.modal", () => modal.remove());

      if (window.ReactOnRails && modal.attr("data-skip-react-init") != "true") {
        await ReactOnRails.reactOnRailsPageLoaded();
      }

      modal.on('shown.bs.modal', () => {
        const event = new CustomEvent('loomly.modal.shown');
        document.dispatchEvent(event);
      });
      modal.modal({ show: true, backdrop: 'static', keyboard: false });
    },
    error: (jqXHR) => {
      const errorMessage = (jqXHR.responseJSON?.errors && jqXHR.responseJSON?.errors.join(", ")) || jqXHR.responseText;
      if (!alert(`An error occurred. Please try again. The response was: ${errorMessage}`)) {
        jqXHR.responseJSON?.reload && window.location.reload();
      }
    },
    complete: () => {
      currentTarget.html(label);
      currentTarget.removeClass("disabled");
      currentTarget.prop("disabled", false);
    }
  });

  if ($(".modal.show-modal").length) {
    $(".modal.show-modal").modal('show');
  }
});

// Move static Bootstrap modals to body on mobile-web-ai to escape
// scroll containers that break position:fixed on mobile browsers.
$(document).on('show.bs.modal', '.modal', function () {
  if (
    document.body.classList.contains('mobile-web-ai') &&
    !this.closest('body > .modal') &&
    this.getAttribute('data-skip-mwai-move') !== 'true'
  ) {
    this.setAttribute('data-mwai-moved', 'true');
    document.body.appendChild(this);
  }
});

// Hide modals before navigating away.
$(document).on('turbo:before-visit', () => {
  // We first remove the `fade` class to avoid a race condition
  // between the Turbo snapshot and the jQuery fade-out animation.
  $('.modal').removeClass('fade show').modal('hide');
  $('.modal-backdrop').remove();
  $('body').removeClass('modal-open');
  // Remove modals that were moved to body to prevent duplicate IDs
  // after Turbo replaces the page content with a new modal instance.
  $('.modal[data-mwai-moved]').remove();
});

function showUsageLimitVariant($modal, variant) {
  $modal.find('.loomly-ai-usage-limit-variant').hide();
  $modal.find('.loomly-ai-usage-limit-variant[data-variant="' + variant + '"]').css('display', '');
}

function initUsageLimitModal() {
  var $modal = $('#usage-limit-modal');
  if (!$modal.length) return;

  var isBeyond = $modal.attr('data-is-beyond') === 'true';
  var beyondTrial = $modal.attr('data-beyond-trial') === 'true';
  var beyondCanceled = $modal.attr('data-beyond-canceled') === 'true';
  var isCollaborator = $modal.attr('data-is-collaborator') === 'true';
  var isMaxPlan = isCollaborator || (isBeyond && !beyondTrial && !beyondCanceled);

  if (isMaxPlan) {
    $modal.find('.loomly-ai-usage-limit-not-max-plan').hide();
    $modal.find('.loomly-ai-usage-limit-max-plan').css('display', '');
  } else {
    $modal.find('.loomly-ai-usage-limit-not-max-plan').css('display', '');
    $modal.find('.loomly-ai-usage-limit-max-plan').hide();
    var variant = beyondTrial ? 'beyond_trial' : beyondCanceled ? 'beyond_canceled' : 'default';
    showUsageLimitVariant($modal, variant);
  }
}

$(initUsageLimitModal);
$(document).on('turbo:load', initUsageLimitModal);

$(document).ajaxError(function(_event, jqXHR) {
  if (jqXHR.status === 402 && jqXHR.responseJSON?.code === 'usage_limit_reached') {
    var data = jqXHR.responseJSON;
    var modalId = data.limit_type === 'social_listening_usage' ? '#social-listening-limit-modal' : '#usage-limit-modal';
    var $modal = $(modalId);

    var isSocialListeningModal = data.limit_type === 'social_listening_usage';
    var shouldShowMaxPlan = data.is_collaborator || data.is_on_max_plan || (isSocialListeningModal && (data.beyond_trial || data.beyond_canceled));

    if (shouldShowMaxPlan) {
      $modal.find('.loomly-ai-usage-limit-not-max-plan').hide();
      $modal.find('.loomly-ai-usage-limit-max-plan').css('display', '');
    } else {
      $modal.find('.loomly-ai-usage-limit-not-max-plan').css('display', '');
      $modal.find('.loomly-ai-usage-limit-max-plan').hide();

      var variant = data.beyond_trial ? 'beyond_trial' : data.beyond_canceled ? 'beyond_canceled' : 'default';
      showUsageLimitVariant($modal, variant);

      if (data.checkout_path) {
        $modal.find('.loomly-ai-usage-limit-cta-btn[data-variant="' + variant + '"]').filter('a').attr('href', data.checkout_path);
      }
    }
    $modal.data('paywall-trigger', data.paywall_trigger);
    $modal.addClass('active');

    if (window.trackPicoUserAction) {
      var eventName = shouldShowMaxPlan ? 'ai_limit_reached' : 'paywall_displayed';
      var info = { paywall_trigger: data.paywall_trigger || '' };
      if (data.plans_displayed) info.plans_displayed = data.plans_displayed;
      if (data.offer_type) info.offer_type = data.offer_type;
      if (data.offer_duration) info.offer_duration = data.offer_duration;
      window.trackPicoUserAction(eventName, info);
    }
  }
});

$(document).on('click', '.loomly-ai-usage-limit-cta-btn', function(e) {
  var $overlay = $(this).closest('.loomly-ai-usage-limit-overlay');
  var trigger = $overlay.data('paywall-trigger');
  var prefix = $overlay.data('event-prefix');
  if (prefix && window.trackPicoUserAction) {
    window.trackPicoUserAction(prefix + '_upgrade_clicked', { paywall_trigger: trigger || '' });
  }
  $overlay.removeClass('active');
  if (this.href) {
    e.preventDefault();
    window.location.href = this.href;
  }
});

$(document).on('click', '.loomly-ai-usage-limit-overlay .btn-success:not([data-usage-limit-dismiss])', function(e) {
  e.preventDefault();
  var $overlay = $(this).closest('.loomly-ai-usage-limit-overlay');
  var trigger = $overlay.data('paywall-trigger');
  var prefix = $overlay.data('event-prefix');
  if (prefix && window.trackPicoUserAction) {
    window.trackPicoUserAction(prefix + '_upgrade_clicked', { paywall_trigger: trigger || '' });
  }
  window.location.href = this.href;
});

$(document).on('click', '[data-usage-limit-dismiss]', function() {
  var $overlay = $(this).closest('.loomly-ai-usage-limit-overlay');
  var prefix = $overlay.data('event-prefix');
  if (prefix && window.trackPicoUserAction) {
    window.trackPicoUserAction(prefix + '_dismissed', { paywall_trigger: $overlay.data('paywall-trigger') || '' });
  }
  $overlay.removeClass('active');
});

$(document).on('show.bs.modal', '#coming-soon-modal', function (e) {
  const $modal = $(this);
  const $trigger = $(e.relatedTarget);
  const feature = $trigger.attr('data-trigger-feature') || 'default';

  $modal.removeClass(function (_i, cls) {
    return (cls.match(/\bfdt-\S+/g) || []).join(' ');
  });
  if (feature !== 'default') {
    $modal.addClass('fdt-' + feature);
  }
  $modal.data('current-feature', feature);

  const tabLabel = $trigger.attr('data-trigger-tab-label');
  const tabDesc = $trigger.attr('data-trigger-tab-desc');
  if (tabLabel) {
    $modal.find('.js-fdt-feature-name').text(tabLabel);
  }
  if (tabDesc) {
    $modal.find('.js-fdt-feature-desc').text(tabDesc);
  }

  if (window.trackPicoUserAction) {
    const uiState = window.getLoomlyAiUiState ? window.getLoomlyAiUiState() : {};
    window.trackPicoUserAction('loomly_ai_fake_door_modal_displayed', {
      ...uiState,
      trigger_source: $trigger.attr('data-trigger-source') || 'unknown',
      trigger_feature: feature
    });
  }
});

$(document).on('click', '.js-fdt-notify', function () {
  const feature = $(this).closest('#coming-soon-modal').data('current-feature') || 'unknown';

  if (window.trackPicoUserAction) {
    const uiState = window.getLoomlyAiUiState ? window.getLoomlyAiUiState() : {};
    window.trackPicoUserAction('loomly_ai_fake_door_notify_clicked', {
      ...uiState,
      trigger_feature: feature
    });
  }
});

// --- App Store / Play Store rating prompt ---

function appStoreReviewRequestNative() {
  try {
    if (window.MobileMessages && typeof window.MobileMessages.post_message === 'function') {
      window.MobileMessages.post_message({ action: 'request_app_store_review', data: {} });
    }
  } catch (e) {
    if (window.Bugsnag && typeof window.Bugsnag.notify === 'function') {
      window.Bugsnag.notify(e);
    }
  }
}

$(document).on('turbo:load', function () {
  var $appStoreReviewDirect = $('[data-app-store-review-direct]');

  // Direct native prompt: fire-and-forget, no consume
  if ($appStoreReviewDirect.length && !$appStoreReviewDirect.data('app-store-review-requested')) {
    $appStoreReviewDirect.data('app-store-review-requested', true);
    appStoreReviewRequestNative();
  }
});

$(document).on('turbo:before-cache', function () {
  $('[data-app-store-review-direct]').remove();
});

$(document).on('hidden.bs.modal', '#coming-soon-modal', function () {
  const $modal = $(this);
  $modal.find('.js-fdt-feature-name').text('Link-in-Bio');
  $modal.find('.js-fdt-feature-desc').text(
    'a beautiful, customizable link-in-bio page so you can share all your links, social profiles, and content'
  );
});
